<template>

  <div class="row">
    <div class="col-lg-12">
      <div class="ibox ">
        <div class="ibox-content">

          <slot />

        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: "TemplateCard",
};
</script>


// WEBPACK FOOTER //
// src/components/Template/TemplateCard.vue